<template>
  <Navigation/>
  <router-view v-slot="{ Component }">
      <component :is="Component" />
  </router-view>
</template>

<script>
import Navigation from './components/Navigation'

export default {
  name: 'App',
  components: {
    Navigation
  },
  data() {
    return {
      images2: null,
      sensorAccess: null,
      window: { width: null, height: null }
    }
  },
  computed: {
    currentSeries() {
      return this.$store.state.$active;
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.checkForMobile();      
  },
  methods: {
    handleResize() {
            this.checkForMobile(); 
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
    },
    checkForMobile() {
      let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (window.innerWidth <= 800 || isMobile) {
        this.$store.state.$mobile = true;
      }
      else { 
        this.$store.state.$mobile = false;
      }
    },
  }
}
</script>

<style>
</style>
